

































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import tabs from '@/views/AiiTasks/Tabs.vue'
import investTabs from '@/views/investigate/Tabs.vue'
import HomeInvestigateTabs from '@/views/homeInvestigate/HomeInvestigateTabs.vue'

@Component({
	components: {
		tabs,
		investTabs,
		HomeInvestigateTabs,
	},
})
export default class SuperTabs extends Vue {
	@Prop()
	public task!: any

	@Prop()
	public injured!: any

	@Prop()
	public order!: any

	@Prop()
	private boardImageList: any

	@Prop()
	public orderId!: string

	@Prop()
	private show!: any

	@Prop()
	private activeKey!: any
}
